import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

export default function Calendar({
    events = [],
    // for example:
    // [
    //     { title: 'event 1', date: '2024-08-01' },
    //     { title: 'event 2', date: '2024-08-02' }
    // ]
    onMonthChange = (start, end) => { },
    onEventClick = () => { },
    renderEventContent
}) {
    return (
        <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            showNonCurrentDates={false}
            fixedWeekCount={false}
            events={events}
            eventContent={renderEventContent}
            eventClick={onEventClick}

            themeSystem="bootstrap5"

            locale="IT"
            firstDay={1}
            datesSet={(dateInfo) => {
                onMonthChange(dateInfo.start, dateInfo.end);
            }
            }
        />
    )
}